import React from "react";

import Connect from '../assets/icons/icon_fetch.png';

const Fetching = () => {

  return (
    <>
      <div className="white-modal">
        <div className="modal-content">
          {/* <img src={Connect} alt="connect-internet" /> */}
        </div>
      </div>
    </>
  )
}

export default Fetching